import { get } from 'lodash';

import { createFetchAction } from '../helpers/fetch';
import {
  getToken, logout, buildInternalApiUrl,
  buildTenantApiUri, constructIntlErrorMessage,
  displayGremlinsToaster,
} from '../../helpers';

// Actions
export const GET_COMPANIES = 'GET_COMPANIES';
export const GET_COMPANY = 'GET_COMPANY';
export const UPDATE_ESIGNATURE_PRODUCT_TIER = 'UPDATE_ESIGNATURE_PRODUCT_TIER';

// Action Creators
export function getCompanies(next) {
  const token = getToken();
  const url = next || `${buildInternalApiUrl(token)}/companies`;
  return createFetchAction(GET_COMPANIES, {
    url,
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
    },
  }, 'GETTING_COMPANIES', {
    fallbackAction: logout,
    errorCodes: [401],
  });
}

export function getCompany(companyId, formatMessage) {
  const token = getToken();
  const url = `${buildInternalApiUrl(token)}/companies/${companyId}`;
  const pageFilter = /^.*\/companylist.aspx(?:\?[^?]*$)?$/i;
  return createFetchAction(GET_COMPANY, {
    url,
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
    },
  }, 'GETTING_COMPANY', {
    fallbackAction: logout,
    errorCodes: [401],
    failureMessage: {
      exclusions: [pageFilter],
      exclusionAction: () => {
        // trigger toaster in AHR
        const messageIds = ['THERE_WAS_A_PROBLEM', 'GETTING_COMPANY', 'PLEASE_TRY_AGAIN'];
        const errorMessage = constructIntlErrorMessage(formatMessage, messageIds, '{0} {1}. {2}');
        displayGremlinsToaster(errorMessage, 'danger', 3000);
      },
    },
  });
}

export function updateEsignatureProductTier(productTierId, formatMessage, onClose) {
  const token = getToken();
  const companyId = get(window, 'asure.appSettings.selectedCompany.companyId');
  const url = `${buildTenantApiUri(token)}/companies/${companyId}/esignatures`;
  const pageFilter = /^.*\/companylist.aspx(?:\?[^?]*$)?$/i;

  return createFetchAction(UPDATE_ESIGNATURE_PRODUCT_TIER, {
    url,
    method: 'PUT',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ productTierId }),
  }, 'UPDATING_ESIGNATURE_PRODUCT_TIER', {
    fallbackAction: logout,
    errorCodes: [401],
    failureMessage: {
      exclusions: [pageFilter],
      exclusionAction: () => {
        // trigger toaster in AHR
        const messageIds = ['THERE_WAS_A_PROBLEM', 'UPDATING_ESIGNATURE_PRODUCT_TIER', 'PLEASE_TRY_AGAIN'];
        const errorMessage = constructIntlErrorMessage(formatMessage, messageIds, '{0} {1}. {2}');
        displayGremlinsToaster(errorMessage, 'danger', 3000);
        onClose();
      },
    },
  });
}

const INITIAL_STATE = {
  results: [],
  selectedCompany: {
    esignatureProductTier: {},
  },
};

export function companies(state = INITIAL_STATE, action) {
  switch (action.type) {
    case GET_COMPANIES: {
      const { payload, payload: { next } = {} } = action;
      const { results } = state;
      const payloadResults = payload && payload.results ? payload.results : [];
      return {
        ...state,
        results: [
          ...results,
          ...payloadResults,
        ],
        next,
      };
    }
    case GET_COMPANY: {
      const { payload } = action;
      return {
        ...state,
        selectedCompany: payload,
      };
    }
    case UPDATE_ESIGNATURE_PRODUCT_TIER: {
      const { payload } = action;

      return {
        ...state,
        selectedCompany: { ...state.selectedCompany, esignatureProductTier: payload },
      };
    }
    default:
      break;
  }
  return state;
}



// WEBPACK FOOTER //
// ./src/modules/companies/companies.js